import React from 'react';
import { Search, RefreshCcw, Bell, ChevronDown } from 'lucide-react';
import { IconButton } from '../ui';

export function AppHeader({
  title = 'Fleet',
  subtitle = '203 devices · Goa region',
  userName = 'User',
  userTimestamp = '',
  unreadAlerts = 0,
  onRefresh,
  onBell,
  onSearch,
}) {
  return (
    <header
      role="banner"
      className="h-[54px] shrink-0 bg-surface border-b border-line flex items-center gap-4 px-4"
    >
      <div className="flex items-baseline gap-2 min-w-0">
        <h1 className="text-[15px] font-semibold text-ink truncate">{title}</h1>
        {subtitle && (
          <span className="text-[12px] text-ink-3 truncate">· {subtitle}</span>
        )}
      </div>

      <div className="flex-1" />

      <button
        type="button"
        onClick={onSearch}
        className="hidden md:flex items-center gap-2 w-[340px] h-[34px] px-3 rounded-lg bg-bg border border-line text-ink-3 hover:bg-surface-2 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-ring"
      >
        <Search size={15} strokeWidth={1.7} />
        <span className="text-[13px] flex-1 text-left">Search devices, trips, geofences…</span>
        <kbd className="font-mono text-[10.5px] text-ink-3 bg-surface border border-line rounded px-1.5 py-0.5">⌘K</kbd>
      </button>

      <div className="flex items-center gap-2">
        <IconButton icon={RefreshCcw} onClick={onRefresh} label="Refresh data" />
        <IconButton icon={Bell} onClick={onBell} label="Alerts" badge={unreadAlerts > 0} />
      </div>

      <div className="w-px h-6 bg-line" />

      <div className="flex items-center gap-2.5 pr-1">
        <div className="w-8 h-8 rounded-full bg-accent-soft text-accent flex items-center justify-center text-[12px] font-semibold">
          {userName.slice(0, 1).toUpperCase()}
        </div>
        <div className="hidden sm:flex flex-col leading-tight">
          <span className="text-[12.5px] font-semibold text-ink">{userName}</span>
          {userTimestamp && (
            <span className="font-mono text-[10.5px] text-ink-3">{userTimestamp}</span>
          )}
        </div>
        <ChevronDown size={14} strokeWidth={1.7} className="text-ink-3" />
      </div>
    </header>
  );
}

export default AppHeader;
